"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetPerformanceData = exports.removedPerformanceCalculation = exports.addedPerformanceCalculation = exports.updatedPerformanceCalculation = exports.setPerformanceCalculations = exports.removedPerformanceDataSource = exports.addedPerformanceDataSource = exports.updatedPerformanceDataSource = exports.setPerformanceDataSources = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    sources: [],
    calculations: [],
};
const performanceDataSourcesSlice = (0, toolkit_1.createSlice)({
    name: 'performanceDataSources',
    initialState,
    reducers: {
        // sources
        setPerformanceDataSources: (_state, action) => {
            _state.sources = action.payload ?? [];
        },
        updatedPerformanceDataSource: (state, action) => {
            const index = state.sources.findIndex((source) => source.id === action.payload.id);
            if (index < 0)
                return;
            state.sources[index] = action.payload;
        },
        addedPerformanceDataSource: (state, action) => {
            state.sources.push(action.payload);
        },
        removedPerformanceDataSource: (state, action) => {
            state.sources = state.sources.filter((source) => source.id !== action.payload);
        },
        // calculations
        setPerformanceCalculations: (_state, action) => {
            _state.calculations = action.payload ?? [];
        },
        updatedPerformanceCalculation: (state, action) => {
            const index = state.calculations.findIndex((source) => source.id === action.payload.id);
            if (index < 0)
                return;
            state.calculations[index] = action.payload;
        },
        addedPerformanceCalculation: (state, action) => {
            state.calculations.push(action.payload);
        },
        removedPerformanceCalculation: (state, action) => {
            state.calculations = state.calculations.filter((source) => source.id !== action.payload);
        },
        // whole state
        resetPerformanceData: (_state) => {
            return initialState;
        },
    },
});
_a = performanceDataSourcesSlice.actions, 
// sources
exports.setPerformanceDataSources = _a.setPerformanceDataSources, exports.updatedPerformanceDataSource = _a.updatedPerformanceDataSource, exports.addedPerformanceDataSource = _a.addedPerformanceDataSource, exports.removedPerformanceDataSource = _a.removedPerformanceDataSource, 
// calculations
exports.setPerformanceCalculations = _a.setPerformanceCalculations, exports.updatedPerformanceCalculation = _a.updatedPerformanceCalculation, exports.addedPerformanceCalculation = _a.addedPerformanceCalculation, exports.removedPerformanceCalculation = _a.removedPerformanceCalculation, 
// whole state
exports.resetPerformanceData = _a.resetPerformanceData;
exports.default = performanceDataSourcesSlice.reducer;
